/**
 * Root de la app.
 *
 * Monta los providers globales + el router. Catálogos (ubicaciones, productos,
 * clientes) se fetchean vía TanStack Query con caching automático — no hace
 * falta hidratación manual al boot.
 */

import { Providers } from '@/app/providers';
import { AppRouter } from '@/app/router';

export function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
